/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menu_Language_Selector_AriaInputs */

const bn_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভাষা নির্বাচন করুন`)
};

const de_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache auswählen`)
};

const el_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιλέξτε γλώσσα`)
};

const en_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select language`)
};

const es_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar idioma`)
};

const fr_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisir la langue`)
};

const hi_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा चुने`)
};

const hu_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válasszon nyelvet`)
};

const id_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih bahasa`)
};

const it_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la lingua`)
};

const ja_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語を選択してください`)
};

const ko_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언어 선택`)
};

const nl_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer taal`)
};

const pl_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz język`)
};

const pt_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o idioma`)
};

const ru_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите язык`)
};

const sv_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj språk`)
};

const tr_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dil seçin`)
};

const uk_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть мову`)
};

const vi_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ngôn ngữ`)
};

const zh_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择语言`)
};

const zh_hant_menu_language_selector_aria = /** @type {(inputs: Menu_Language_Selector_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇語言`)
};

/**
* | output |
* | --- |
* | "Select language" |
*
* @param {Menu_Language_Selector_AriaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const menu_language_selector_aria = /** @type {((inputs?: Menu_Language_Selector_AriaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menu_Language_Selector_AriaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_menu_language_selector_aria(inputs)
	if (locale === "de") return de_menu_language_selector_aria(inputs)
	if (locale === "el") return el_menu_language_selector_aria(inputs)
	if (locale === "en") return en_menu_language_selector_aria(inputs)
	if (locale === "es") return es_menu_language_selector_aria(inputs)
	if (locale === "fr") return fr_menu_language_selector_aria(inputs)
	if (locale === "hi") return hi_menu_language_selector_aria(inputs)
	if (locale === "hu") return hu_menu_language_selector_aria(inputs)
	if (locale === "id") return id_menu_language_selector_aria(inputs)
	if (locale === "it") return it_menu_language_selector_aria(inputs)
	if (locale === "ja") return ja_menu_language_selector_aria(inputs)
	if (locale === "ko") return ko_menu_language_selector_aria(inputs)
	if (locale === "nl") return nl_menu_language_selector_aria(inputs)
	if (locale === "pl") return pl_menu_language_selector_aria(inputs)
	if (locale === "pt") return pt_menu_language_selector_aria(inputs)
	if (locale === "ru") return ru_menu_language_selector_aria(inputs)
	if (locale === "sv") return sv_menu_language_selector_aria(inputs)
	if (locale === "tr") return tr_menu_language_selector_aria(inputs)
	if (locale === "uk") return uk_menu_language_selector_aria(inputs)
	if (locale === "vi") return vi_menu_language_selector_aria(inputs)
	if (locale === "zh") return zh_menu_language_selector_aria(inputs)
	return zh_hant_menu_language_selector_aria(inputs)
});